export default {
	change_password: "Modifier le mot de passe",
	control_pannel: "Panneau de Commande",
	idiom: "Idiome",
	messages: "Messages",
	my_profile: "Mon profil",
	navbar_about_title: "Savoir plus",
	no_notification_available: "Aucune notification disponible",
	no_notifications_avaliable: "Aucune notification disponible.",
	sign_out: "Déconnexion"
}